import { useEffect, useState } from "react";
import {
  fetchMarketCardOnHomePage,
  MarketCardOnHomePage,
} from "../api/contentful";

export function useMarketCardOnHomePage() {
  const [data, setData] = useState<MarketCardOnHomePage | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchMarketCardOnHomePage()
      .then((res) => setData(res))
      .catch(
        (err) =>
          setError(err.message || "Failed to load market card on home page"),
      )
      .finally(() => setLoading(false));
  }, []);

  return { data, loading, error };
}
